import { useEffect, useState } from "react"

import { Spin, Typography } from 'antd'
import { approveSignupThunk } from "features/user/model/slice/userSlice"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useAppDispatch } from "shared/config/store"
import { ROUTES } from "shared/constants/routesPaths"
import styled from 'styled-components'
import { SIGNUP_APPROVAL_HASH_PARAM_NAME } from "shared/utils/urlUtils"

import { setIsConfirmationErrorModalOpen, setIsConfirmationSuccessModalOpen } from '../../features/common/model/slice/appSlice'

export const SignupApprovalPage = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const hash = searchParams.get(SIGNUP_APPROVAL_HASH_PARAM_NAME)

  const [status, setStatus] = useState<"loading" | "success" | "error">("loading")

  useEffect(() => {
    if (!hash) {
      navigate(ROUTES.dashboard.allAssets)
      return
    }

    dispatch(approveSignupThunk({ hash }))
      .unwrap()
      .then((response) => {
        setStatus("success")
        dispatch(setIsConfirmationSuccessModalOpen(true))
      })
      .catch(() => {
        setStatus("error")
        dispatch(setIsConfirmationErrorModalOpen(true))
      })
  }, [dispatch, hash])

  return (
    status === "loading" && <StyledSpinner />
  )
}

export const StyledSpinner = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
`
